// extracted by mini-css-extract-plugin
module.exports = {"header":"nPNf8","wrapper":"_1YIRg","headerWrapper":"_2QHbe","headerLink":"_3mDJz","sectionChannels":"_3WVAL","channels":"_2IktB","programs":"_1WbLu","desktop":"_2qPe2"};